import { useQuery } from "@tanstack/react-query";
import { fetchAdminSettings } from "@veorest/api-client";

/**
 * Real console capability gates (Settings → Features → `feature_toggles`).
 * Missing keys default to ENABLED so existing behavior is preserved.
 */
export function useAdminFeatureFlags() {
  const settings = useQuery({ queryKey: ["admin-settings"], queryFn: fetchAdminSettings });
  const toggles = (settings.data?.settings?.feature_toggles?.value ?? {}) as Record<string, unknown>;

  return {
    isLoading: settings.isLoading,
    reportsExport: toggles.reports_export !== false,
    manualPayments: toggles.manual_payments !== false,
  };
}
